import { forwardRef, type Ref, type SVGProps } from "react";
function SvgMailWarning(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={90}
        height={60}
        x={43}
        y={30}
        stroke="url(#mail-warning_svg__a)"
        strokeWidth={10}
        rx={16}
      />
      <path
        stroke="#0D2B57"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m52 39 37.029 25L124 39"
      />
      <rect width={39} height={39} x={113.5} y={54.5} fill="#BD6801" rx={19.5} />
      <rect width={39} height={39} x={113.5} y={54.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.51}
        d="M133 68v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="mail-warning_svg__a"
          x1={88}
          x2={88}
          y1={30}
          y2={90}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FFE3C3" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMailWarning);
export default ForwardRef;
